import { render } from "./CargoShow.vue?vue&type=template&id=a3b5e846"
import script from "./CargoShow.vue?vue&type=script&lang=js"
export * from "./CargoShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__